import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Heart, ShoppingBag, ChevronDown, Menu, X } from "lucide-react";
import Nestora from "../images/Nestora.png";
import Profile from "./Profile";
import Dropdown from "./DropDown";
import { category, shopCategories, supportCategories } from "../db/Categories";
import useUserData from "../hooks/useUserData";
import Shimmer from "./Shimmer";

const Navbar = () => {
  const [shop, setShop] = useState(false);
  const [categories, setCategories] = useState(false);
  const [support, setSupport] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const userdata = useUserData();
  const navigate = useNavigate();

  if (!userdata) return <Shimmer />;

  return (
    <div className="p-4 bg-white/60 shadow-md">
      {/* Top Navbar */}
      <div className="flex justify-between items-center">
        {/* Logo */}
        <img
          src={Nestora}
          className="w-16 h-16 cursor-pointer"
          alt="Nestora"
          onClick={() => navigate("/mainpage")}
        />

        {/* Desktop Menu */}
        <ul className="hidden md:flex gap-6 items-center">
          <li
            className="relative group cursor-pointer hover:bg-gray-200 rounded-lg px-3 py-2"
            onMouseEnter={() => setShop(true)}
            onMouseLeave={() => setShop(false)}
          >
            Shop <ChevronDown className="inline-block" />
            {shop && <Dropdown shopCategories={shopCategories} />}
          </li>

          <li
            className="relative group cursor-pointer hover:bg-gray-200 rounded-lg px-3 py-2"
            onMouseEnter={() => setCategories(true)}
            onMouseLeave={() => setCategories(false)}
          >
            Categories <ChevronDown className="inline-block" />
            {categories && <Dropdown shopCategories={category} />}
          </li>

          <li
            className="relative group cursor-pointer hover:bg-gray-200 rounded-lg px-3 py-2"
            onMouseEnter={() => setSupport(true)}
            onMouseLeave={() => setSupport(false)}
          >
            Support <ChevronDown className="inline-block" />
            {support && <Dropdown shopCategories={supportCategories} />}
          </li>

          <li className="hover:bg-gray-200 rounded-lg px-3 py-2">
            <Link to="/about">About</Link>
          </li>
          <li className="hover:bg-gray-200 rounded-lg px-3 py-2">
            <Link to="/contact">Contact</Link>
          </li>
        </ul>

        {/* Right Icons */}
        <div className="hidden md:flex items-center gap-6">
          <Link to="/liked">
            <Heart className="w-8 h-8 hover:bg-gray-200 p-2 rounded-full" />
          </Link>
          <ShoppingBag
            className="w-8 h-8 hover:bg-gray-200 p-2 rounded-full cursor-pointer"
            onClick={() => navigate("/cart")}
          />
          <Profile />
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <ul className="md:hidden flex flex-col gap-4 mt-4 bg-white shadow-lg p-4 rounded-lg">
          <li className="block p-2" onClick={() => setShop(!shop)}>
             Shop
          </li>
          <li>
            <Link to="/" className="block p-2" onClick={() => setMenuOpen(false)}>Home</Link>
          </li>
          <li>
            <Link to="/categories" className="block p-2" onClick={() => setMenuOpen(false)}>Categories</Link>
          </li>
          <li>
            <Link to="/support" className="block p-2" onClick={() => setMenuOpen(false)}>Support</Link>
          </li>
          <li>
            <Link to="/about" className="block p-2" onClick={() => setMenuOpen(false)}>About</Link>
          </li>
          <li>
            <Link to="/contact" className="block p-2" onClick={() => setMenuOpen(false)}>Contact</Link>
          </li>
          <li className="flex gap-4 flex-col">
            <div className="flex">
            <Link to="/liked">
              <Heart className="w-8 h-8 hover:bg-gray-200 p-2 rounded-full" />
            </Link>
            <ShoppingBag
              className="w-8 h-8 hover:bg-gray-200 p-2 rounded-full cursor-pointer"
              onClick={() => navigate("/cart")}
            />
            </div>
            <Profile />
          </li>
        </ul>
      )}
    </div>
  );
};

export default Navbar;
